import React, { useState } from 'react';
import { Row, Col, Card, Divider, Typography, Segmented } from 'antd';
import NivoPieChart from "../../../charts/nivo/NivoPieChart";
import NivoBarChart from "../../../charts/nivo/NivoBarChart";

import {BarChartRounded, PieChartRounded} from "@mui/icons-material";


const PortfolioChart = ({ data, chartType='pie' }) => {
  const chartData = ( chartType === 'pie' ?
      [...data].map(({ symbol, wgt }) =>
          ({ id: symbol, value: wgt * 100 })) : [...data].map(({ symbol, wgt }) => ({id: symbol, [symbol]: wgt * 100}))
  )
  return (
      <Card bordered={false} className={'gapless'}>
          <div style={{width: '100%', height: 700}}>
              {chartType==='pie' && (
                  <NivoPieChart radius={0.3} data={chartData} showLabels={false}  />
              )}
              {chartType==='bar' && (
                  <NivoBarChart data={chartData} keys={[...chartData].map(x=>x.id)} showLegend={false} />
              )}
          </div>
          <Divider/>
      </Card>
  )
};


const TickerGroupComparison = ({ originalPortfolio, reducedPortfolio }) => {
    const [chartType, setChartType] = useState('pie');
    const fullPortfolio = [...originalPortfolio, ...reducedPortfolio];
  return (
      <>
          <Row>
              <Segmented
                  onChange={setChartType}
                  options={[
                      {value: 'bar', icon: <BarChartRounded/>},
                      {value: 'pie', icon: <PieChartRounded/>}
                  ]}
              />
          </Row>
          <Divider/>
          <Row gutter={16}>
              <Col span={12}>
                <Typography.Title level={4}>
                    Reduced Set Portfolio ({reducedPortfolio.length})
                </Typography.Title>
                <PortfolioChart data={reducedPortfolio} chartType={chartType} />
              </Col>
              <Col span={12}>
                  <Typography.Title level={4}>
                    Original Portfolio ({fullPortfolio.length})
                  </Typography.Title>
                  <PortfolioChart data={fullPortfolio} chartType={chartType} />
              </Col>
          </Row>
      </>
  );
};

export default TickerGroupComparison;